import { Div } from '@codesuma/baseline'
import { ChoiceSlide, DateSlide, IChoice, TitleSlide } from '../../components/wizard'
import { IDayCell } from '../../services/calendar'
import { Reminder } from '../../services/occasion-repeat'
import reminders from '../../services/reminders'
import { Draft, EntryKind } from './draft'
import { EditorSession } from './session'
import { SlideId } from './flow'
import { CalendarSlide, OccasionRepeatSlide } from './occasion-steps'
import { DetailsSlide, RepeatSlide, WhenSlide } from './steps'
import style from './index.module.css'

export type WizardSlide = ReturnType<typeof Div> & { focus?: () => void }
const REMINDERS: IChoice<Reminder>[] = [
    { value: 'none', label: 'بدون یادآوری' },
    { value: 'week', label: 'یک هفته قبل' },
    { value: 'day', label: 'یک روز قبل' },
    { value: 'hour', label: 'یک ساعت قبل' },
]

export function buildSlide(id: SlideId, s: EditorSession): WizardSlide {
    const d: Draft = s.draft
    switch (id) {
        case 'kind': {
            const base = ChoiceSlide<EntryKind>('چه چیزی اضافه کنیم؟', [
                { value: 'occasion', label: 'تولد یا سالگرد', note: 'یک روز کامل؛ با تکرار شمسی، قمری یا میلادی' },
                { value: 'event', label: 'قرار یا برنامه', note: 'با ساعت، مدت و تکرار روزانه، هفتگی، ماهانه یا سالانه' },
            ], d.kind)
            base.on('pick', (value: EntryKind) => {
                d.kind = value
                base.emit('change')
            })
            return base
        }
        case 'title': {
            const base = TitleSlide(d.title, { heading: 'نام رویداد', placeholder: 'مثلاً تولد یک دوست یا جلسه تیم' })
            base.on('text', (value: string) => { d.title = value; base.emit('change') })
            base.on('enter', () => base.emit('advance'))
            return base
        }
        case 'day': {
            const base = DateSlide('چه روزی؟', s.day)
            base.on('pick', (day: IDayCell & { wd: number }) => { s.day = day; base.emit('change') })
            return base
        }
        case 'when': return WhenSlide(d)
        case 'details': return DetailsSlide(d)
        case 'repeat': return d.kind === 'occasion' ? OccasionRepeatSlide(d) : RepeatSlide(d)
        case 'calendar': {
            const base = CalendarSlide(d, s.day)
            if (s.adopting) {
                const note = Div('تاریخ این رویداد در امروز تنظیم می‌شود؛ رویداد اصلی در تقویم گوشی جداگانه باقی می‌ماند.')
                note.addClass(style.hint)
                base.append(note)
            }
            return base
        }
        case 'reminder': {
            const base = ChoiceSlide('یادآوری', REMINDERS, d.reminder)
            base.on('pick', (value: Reminder) => {
                d.reminder = value
                base.emit('change')
                if (value !== 'none') reminders.askWebPermission()
            })
            return base
        }
    }
}
